module.exports = __webpack_public_path__ + "img/bytedance.d2143bd8.png";